<template>
	<div class="pre-number">
		<label class="pre-inline">{{pre_item.name}}:</label>
		<input type="number" :class="[pre_item.class==''?'long1':pre_item.class]" v-model="pre_item.val"
			:placeholder="pre_item.note" :readonly="(pre_item.r=='1') ? 'readonly':false " @keyup.enter="val_back(1)"
			@change="val_back('0')" />
		<em class="pre-em" v-show="pre_item.w=='1'">*</em><em class="pre-em" v-show="pre_item.w=='0'"></em>
	</div>
</template>

<script>
	//
	export default {
		name: "hj-number",
		data() {
			return {
				pre_item: {},
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		created() {
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			// console.log(this.pre_item);
		},
		watch: {
			inData(val) {
				this.pre_item = {};
				this.pre_item = JSON.parse(this.inData);
			}
		},
		// mounted: function() {
		//   console.log('hj-number 组件 mounted');
		//   if (typeof(this.inData) !== 'undefined' && this.inData != '') {
		//     this.pre_item = {};
		//     this.pre_item = JSON.parse(this.inData);
		//   }
		// },
		activated: function() {
			// console.log('激活');
			// console.log(this.inData);
			if (typeof(this.inData) !== 'undefined' && this.inData != '') {
				// console.log('hj-number 组件激活时调用 激活');
				this.pre_item = {};
				this.pre_item = JSON.parse(this.inData);
			}
		},
		deactivated: function() {
			// console.log('hj-input 组件激活时调用 停用');
			this.pre_item = {};
		},
		methods: {
			val_back: function(type) {
				// 取消 
				//  响应 save
				let str = ''
				if (type == '1') {
					str = 'save';
				}
				this.$emit('com-event', this.pre_item, str);
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-number {
		display: flex;
		align-items: center;
	}

	.pre-inline {
		display: inline-block;
		vertical-align: middle;
		margin-right: 2px;
		min-width: 108px;
	}

	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 10px;
	}
</style>